export class IAlert {
  public message!: string;
  public type!: string;
  public title?: string;
}
